import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [
	{
	    path: '/index',
	    name: 'hospital',
	    component: resolve => {
	        require(['@/views/hospital/index.vue'], resolve);
	    },
	    meta: {
	        title: '去医院'
	    }
	},
    {
        path: '',
        name: 'hospital',
        component: resolve => {
            require(['@/views/hospital/nindex.vue'], resolve);
        },
        meta: {
            title: '去医院'
        }
    },
    {
      path: 'search',
      name: 'hospitalSearch',
      component: resolve => {
          require(['@/views/hospital/search.vue'], resolve);
      },
      meta: {
          title: '去医院搜索'
      }
    },
	{
	  path: 'detail',
	  name: 'hospitalDetail',
	  component: resolve => {
	      require(['@/views/hospital/detail.vue'], resolve);
	  },
	  meta: {
	      title: '医院详情'
	  }
    },
    {
        path: 'searchPage',
        name: 'hospitalSearchPage',
        component: resolve => {
            require(['@/views/hospital/searchPage.vue'], resolve);
        },
        meta: {
            title: '搜索'
        }
    },
	{
	    path: 'introdcution',
	    name: 'introdcution',
	    component: resolve => {
	        require(['@/views/hospital/introdcution.vue'], resolve);
	    },
	    meta: {
	        title: '医院简介'
	    }
	},
	{
	    path: 'productDetail',
	    name: 'productDetail',
	    component: resolve => {
	        require(['@/views/hospital/productDetail.vue'], resolve);
	    },
	    meta: {
	        title: '',
			normal: true
	    }
	},
]

let route = [
  {
    path: '/hospital',
    component: CommomProxy,
    children: child_routes,
  }
]

export default route


// WEBPACK FOOTER //
// ./src/router/hospital.js